import { render } from "./TutorsAdmin.vue?vue&type=template&id=80bf902c&scoped=true"
import script from "./TutorsAdmin.vue?vue&type=script&lang=js"
export * from "./TutorsAdmin.vue?vue&type=script&lang=js"

import "./TutorsAdmin.vue?vue&type=style&index=0&id=80bf902c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80bf902c"]])

export default __exports__